import type { Theme } from '@mui/material';

export const styles = {
  foreground: {
    transition: 'all 0.5s ease-out',
  },

  centerElement: (theme: Theme) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    textAlign: 'center',
    py: theme.spacing(2),
    justifyContent: 'center',
  }),
};
